/**
 * EarlyPaymentActions
 * Renders 3 action buttons for early payment types.
 * Only visible when credit status is ACTIVE or DELINQUENT and balance > 0.
 */

import { Banknote, FastForward, CheckCircle2 } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import type { EarlyPaymentType } from '@/types/early-payment.types';

interface EarlyPaymentActionsProps {
  creditStatus: string;
  outstandingBalance: number;
  onSelectType: (type: EarlyPaymentType) => void;
}

const ALLOWED_STATUSES = ['ACTIVE', 'DELINQUENT'];

export function EarlyPaymentActions({
  creditStatus,
  outstandingBalance,
  onSelectType,
}: EarlyPaymentActionsProps) {
  // Only show for ACTIVE or DELINQUENT credits with remaining balance
  if (!ALLOWED_STATUSES.includes(creditStatus) || outstandingBalance <= 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="outline"
        size="sm"
        onClick={() => onSelectType('ANTICIPATED')}
      >
        <Banknote size={16} />
        Abono a Capital
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={() => onSelectType('ADVANCED')}
      >
        <FastForward size={16} />
        Pago Adelantado
      </Button>
      <Button
        variant="danger"
        size="sm"
        onClick={() => onSelectType('SETTLEMENT')}
      >
        <CheckCircle2 size={16} />
        Liquidar
      </Button>
    </div>
  );
}
